import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Enums } from '../../enums/enums';
import { RightDrawerTarget } from '../../enums/standalone/right-drawer-target.enum';
import { AbstractAppAuthentication } from '../authentication/authentication.app.abstract';
import { AppErrorHandler } from '../error-dialog/error-handler.app';
import { AppMonitoring } from '../monitoring/monitor.app';

@Injectable({
  providedIn: 'root'
})
export class AppRightDrawer {
  private readonly appAuth = inject(AbstractAppAuthentication);

  readonly isOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _callbackMethod: ((parameter?: any) => void) | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public get callbackMethod(): ((parameter?: any) => void) | undefined {
    return this._callbackMethod;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private set callbackMethod(v: ((parameter?: any) => void) | undefined) {
    this._callbackMethod = v;
  }

  private get organizationId() {
    return this.appAuth.account?.idTokenClaims.selectedOrganization.organizationId;
  }

  constructor(
    private readonly router: Router,
    private readonly appMonitor: AppMonitoring,
    private readonly appErrorHandler: AppErrorHandler
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  open(target: RightDrawerTarget, parameter?: any, callbackMethod?: (parameter?: any) => void): void {
    let hasError = false;
    switch (target) {
      case Enums.RightDrawerTarget.CampaignCreateMaster:
        this.appMonitor.logEvent(this, 'Opening right drawer: Campaign create master');
        this.router.NavigateTo.RightDrawer.CampaignCreateMaster(this.organizationId, parameter?.id);
        break;
      case Enums.RightDrawerTarget.GeolocationDetails:
        this.appMonitor.logEvent(this, 'Opening right drawer: Geolocation details');
        this.router.NavigateTo.RightDrawer.GeolocationDetails(parameter);
        break;
      case Enums.RightDrawerTarget.NotificationDetails:
        this.appMonitor.logEvent(this, 'Opening right drawer: Notification content');
        this.router.NavigateTo.RightDrawer.NotificationDetails(parameter);
        break;
      case Enums.RightDrawerTarget.SendNotificationCreateMaster:
        this.appMonitor.logEvent(this, 'Opening right drawer: Send notification create master');
        this.router.NavigateTo.RightDrawer.SendNotification(this.organizationId, parameter?.campaignId);
        break;
      default:
        this.appErrorHandler.displayErrorDialog(
          this,
          'Invalid component type',
          'The component type is not valid for the right drawer.'
        );
        hasError = true;
        break;
    }
    if (!hasError) {
      this.isOpen.next(true);
      this.callbackMethod = callbackMethod;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  close(callbackParameter?: any): void {
    this.isOpen.next(false);
    if (this.callbackMethod) {
      this.callbackMethod(callbackParameter);
    }
    this.router.navigate([{ outlets: { rightDrawer: null } }]);
  }
}
